<div style="width: 100%;">
    <div class="controls">
        <button mat-stroked-button color="primary" (click)="getCompanies()" [disabled]="submiting">
            <mat-icon>refresh</mat-icon>
            Carregar dados
        </button>
    </div>

    <ng-container *ngIf="submiting">
        <div class="empty-content" style="width: 100%">
            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
        </div>
    </ng-container>

    <ng-container *ngIf="submiting == false">

        <ng-container *ngIf="chartData[0].series.length == 0">
            <div class="empty-content" style="width: 100%">
                Se houver resultado do filtro aparecerá aqui
            </div>
        </ng-container>

        <div *ngIf="chartData[0].series.length > 0">
            <div>
                <span class="mat-display-2">
                    {{ totalCompanies}}
                </span>
                <p class="mat-title">Cadastros completos</p>
            </div>
            <div>
                <div #chartContainer style="height: 500px;">
                    <div style="width: 100%">
                        <h2 style="margin-bottom: 0px">Distribuição por data</h2>
                        <p class="mat-body-1">Últimos 30 </p>
                        <ngx-charts-line-chart [view]="[chartWidth, chartWidth / 4]" [legend]="true" [autoScale]="false"
                            [timeline]="false" [showXAxisLabel]="true" [showYAxisLabel]="true" [xAxis]="true"
                            [yAxis]="true" xAxisLabel="Data" yAxisLabel="Empresas" [timeline]="true"
                            [results]="chartData">
                        </ngx-charts-line-chart>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

</div>